class VariantDBDetails {
  constructor(data, variant, db) {
    this.mainData = data.main_data;
    this.id = `${db.index}-${variant.id}`;
    this.db = db;
    this.variant = variant;
    this.level = 0;
  }

  get region() {
    return this.variant.region;
  }
}

export default VariantDBDetails;
